<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">SMS(문자메시지)</span>
            <span class="txt">센터가 승인 요청한 SMS 발신번호를 확인하고 관리할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <button @click="onClickRouter('/madmin/business/smsNumSetting')">SMS 발신번호 관리</button>
            <button @click="onClickRouter('/madmin/business/smsPayment')">SMS 결제내역</button>
            <button class="on">수신거부번호</button>
        </div>

        <div class="com-table-content com-msg-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 140px" />
                    <col style="width: 240px" />
                    <col style="" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>등록일</button>
                        </th>
                        <th>전화번호</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in rejectionList" :key="item.id">
                        <td>{{ formatDateTime(item.cre_dt) }}</td>
                        <td>{{ formatPhone(item.user_hp) }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';
import paymentApi from '@/assets/js/paymentApi';
import moment from 'moment';
import XLSX from 'xlsx';
import EventBus from '../../../assets/js/eventBus';
export default {
    name: 'messageHistory',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        period(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
            this.onRejectionList();
        },
        startDate(newValue) {
            this.startDate = newValue;
        },
        endDate(newValue) {
            this.endDate = newValue;
        },
        searchSmsType(newValue) {
            this.searchSmsType = newValue;
            this.onRejectionList();
        },
        sendOk(newValue) {
            this.sendOk = newValue;
            this.onRejectionList();
        },
        sender(newValue) {
            this.sender = newValue;
            this.onRejectionList();
        },
    },
    data() {
        return {
            imagePop: false,
            centerId: '',
            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
            periodTypeList: ['오늘', '어제', '최근 일주일', '이번 달', '지난 달', '3개월', '6개월', '12개월'],
            periodTypeValueList: [
                'today',
                'yesterday',
                'lastWeek',
                'thisMonth',
                'prevMonth',
                'threeMonth',
                'sixMonth',
                'year',
            ],
            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],
            pagingInfo: { ...pagingInfo },
            searchStr: '',
            period: '',
            historyList: [],
            msgTypeList: ['SMS', 'LMS', 'MMS'], // 발송유형
            msgTypeValueList: ['S', 'L', 'M'], // 발송유형 value 값
            searchSmsType: '',
            sendOk: '',
            sender: '',
            staffNameList: [],
            staffValList: [],
            img: '', // '/img/temp/popup_1.png',
            rejectionList: [],
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.init();
    },
    methods: {
        // 초기화
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            this.senderList(); // 강사 목록
            this.onRejectionList(); // 수신거부 목록
        },
        //수신거부 조회 API 호출
        async onRejectionList() {
            const response = await paymentApi.get('/admin/api/block/listUser');
            this.rejectionList = response.data;
        },
        formatDateTime(dateTime) {
            return new Date(dateTime).toLocaleDateString('ko-KR');
        },
        formatPhone(value) {
            let phone = value.replace(/[^0-9]/g, ''); // 숫자가 아닌 문자 제거
            phone = phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
            return phone;
        },
        // 발송내욕 조회 API
        getCenterList() {
            // 스웨거 검색: 메시지발송 내역
            const msgType = 'S'; // 문자만 검색
            return api.get(`/admin/api/center/${this.centerId}/message/sms`, {
                params: {
                    msgType,
                    searchStr: this.searchStr,
                    smsType: this.searchSmsType,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    success: this.sendOk,
                    sendNo: '',
                    ...this.pagingInfo,
                },
            });
        },
        // get 수신거부번호
        getCenterList() {
            // 스웨거 검색: 수신거부번호 조회
            return paymentApi.get(`/admin/api/block/listUser`, {});
        },
        // 검색 종료일
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
            return startDate;
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.onRejectionList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.onRejectionList();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = '';
            (this.searchSmsType = ''), (this.searchStr = '');
            this.onRejectionList();
            EventBus.$emit('event:init', 'init');
        },
        // 검색어 입력
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onRejectionList();
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 발송 유형 타입 변환
        convertSmsType(type) {
            if (type === 'S') {
                return 'SMS';
            } else if (type === 'L') {
                return 'LMS';
            } else if (type === 'M') {
                return 'MMS';
            }
        },
        convertSmsMoney(type) {
            if (type === 'S') {
                return '8.5';
            } else if (type === 'L') {
                return '25';
            } else if (type === 'M') {
                return '60';
            }
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onRejectionList();
        },

        getExcel() {
            const dataWS = XLSX.utils.json_to_sheet(this.historyList);
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, 'sendHistory');
            XLSX.writeFile(wb, 'sendHistory.xlsx');
        },
        // 발송자 리스트 조회
        async senderList() {
            try {
                const { data } = await this.fetchSenderList();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                data.forEach((g) => {
                    this.staffNameList.push(g.namee);
                    this.staffValList.push(g.cs_center_staff_id);
                });
                console.log('발송자 리스트', data);
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        fetchSenderList() {
            return api.get(`/admin/api/customer-app/main/center/${this.centerId}/teachers/list`);
        },
        viewImagePop(img) {
            this.imagePop = true;
            this.img = img;
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onRejectionList();
        },

        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
    },
};
</script>
<style lang="scss"></style>
